import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { WizardStepBaseComponent } from '../';
import { TWizardStepId } from '../../../interfaces';

@Component({
    selector: 'app-wizard-step-update-success',
    templateUrl: './wizard-step-update-success.component.html',
    styleUrls: ['../base/wizard-step-base.component.scss', './wizard-step-update-success.component.scss'],
    providers: [{ provide: WizardStepBaseComponent, useExisting: WizardStepUpdateSuccessComponent }],
    imports: [FormsModule, TranslatePipe],
})
export class WizardStepUpdateSuccessComponent extends WizardStepBaseComponent {
    public id: TWizardStepId = 'update-success';
    public nextButtonLabel = 'back';

    public override onBeforeShow(): void {
        // Reset form
        this.form.token = null;
        this.form.tenantName = null;
    }

    @HostListener('keyup.enter')
    public onSubmit(): void {
        this.wizardService.stepSubmit.emit();
    }

    protected submitWizardStep(): Observable<boolean> {
        return of(true);
    }
}
